/* Was die Asset-Oberfläche (Selectbox, Browser) vom Editor und vom Server braucht. Implementiert in assets-ui.tsx, in Tests ersetzbar. */
import type { Pixels } from '../../formats/wad.ts';
import type { AssetEntry, ServerAsset } from '../../model/assets.ts';
import type { UsedTex } from '../../model/texlist.ts';

export type BrowserTab = 'texture' | 'wad' | 'sprite' | 'skybox' | 'sound' | 'model' | 'other';
export const BROWSER_TABS: BrowserTab[] = ['texture', 'wad', 'sprite', 'skybox', 'sound', 'model', 'other'];

export interface WadInfo { count: number; sample: { name: string; px: Pixels | null }[] }

export interface AssetHost {
  /** Server nutzbar (verbunden und angemeldet)? Sonst zeigt die Liste nur, was im Editor geladen ist */
  server(): boolean;
  /** Einträge aus Server-Liste und Editor-Zustand (synchron, aus dem Zwischenspeicher) */
  entries(): AssetEntry[];
  /** Server-Liste neu holen */
  refresh(): Promise<void>;
  /** Meldet Änderungen (Serverliste, geladene Assets); liefert die Abmeldung */
  subscribe(f: () => void): () => void;
  /** Server-Assets ohne Art (z. B. versehentlich hochgeladene .txt) */
  unclassified(): ServerAsset[];
  /** Dateien vom Server löschen (Besitzer oder Admin), liefert die Zahl der gelöschten; die Liste wird danach einmal neu geholt */
  removeMany(paths: string[]): Promise<number>;
  textures(): { loaded: string[]; used: UsedTex[]; active: string; version: string };
  texPixels(name: string): Pixels | null;
  setActiveTex(name: string, apply: boolean): void;
  /** Vorschaubild (geladen: aus dem Editor, sonst vom Server); null, wenn es keines gibt */
  preview(e: AssetEntry): Promise<Pixels | null>;
  wadInfo(e: AssetEntry): Promise<WadInfo | null>;
  /** Asset vom Server in den Editor laden; true bei Erfolg. preview (Skybox): nur zur Ansicht in 3D zeigen, auch wenn sie nicht zum skyname der Karte passt */
  load(e: AssetEntry, opts?: { preview?: boolean }): Promise<boolean>;
  /** Sound abspielen (geladen oder direkt vom Server); liefert eine Funktion zum Stoppen. onEnd kommt am natürlichen Ende. */
  play(e: AssetEntry, onEnd: () => void): Promise<() => void>;
  /** Fehlende, von der Karte gebrauchte Sprites, Modelle und die Skybox vom Server laden (WADs und Sounds laden die Backend-Aktionen) */
  autoLoad(): Promise<number>;
  /** Browser öffnen */
  open(tab?: BrowserTab): void;
}
